import { motion } from 'framer-motion';
import styled from 'styled-components';

export const DraggingWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    aspect-ratio: 1 / 1;
`;

export const ItemWrapper = styled(motion.div)`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    transform-origin: 0 0;
`;
